var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "sticky" }, on: { "after-enter": _vm.slideInContent } },
    [
      _vm.showSticky
        ? _c(
            "div",
            {
              staticClass: "sticky-contact",
              on: { click: _vm.openContactSlidein }
            },
            [
              _c(
                "div",
                { staticClass: "sticky-contact__inner" },
                [
                  _c("transition", { attrs: { name: "contentbox" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "sticky-contact__content",
                        class: _vm.showContent ? "show-content" : ""
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "sticky-contact__text",
                            class: _vm.showText ? "show-text" : ""
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "sticky-contact__text-label" },
                              [_vm._v(_vm._s(_vm.title))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "sticky-contact__text-name" },
                              [_vm._v(_vm._s(_vm.text))]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sticky-contact__circle" }, [
                    _c(
                      "div",
                      { staticClass: "sticky-contact__icon" },
                      [_c("letter-icon")],
                      1
                    )
                  ])
                ],
                1
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }